import { Component, Inject, Input, OnInit } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';

import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'dialog-confirm-action',
  templateUrl: './dialog-confirm-action.component.html',
  styleUrls: ['./dialog-confirm-action.component.scss']
})
export class DialogConfirmActionComponent implements OnInit {
  @Input() message: string;
  @Input() mainBtn: string;
  @Input() isLoading = false;

  private confirmClick: Subject<any> = new Subject();

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<DialogConfirmActionComponent>
  ) {}

  ngOnInit() {
    const { mainBtn } = this.data;
    this.mainBtn = mainBtn;
  }

  handleClose() {
    this.isLoading = false;
    this.dialogRef.close();
  }

  handleConfirm() {
    this.isLoading = true;
    this.confirmClick.next();
  }

  onConfirmClicked() {
    return this.confirmClick;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-confirm-action/dialog-confirm-action.component.ts